import { render, staticRenderFns } from "./Route.template.vue?vue&type=template&id=27eb6c9f&scoped=true&"
var script = {}
import style0 from "./Route.template.vue?vue&type=style&index=0&id=27eb6c9f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb6c9f",
  null
  
)

export default component.exports